import { PDiPModeltypebasicDto } from 'src/services/Client';
import { IReduxState } from '../IReduxState';

export const selectModeltypeColors = (state: IReduxState): string[] =>
  state.derivates.modeltypeColors;

export const selectModeltypebasicPDiPList = (
  state: IReduxState
): PDiPModeltypebasicDto[] => state.derivates.modeltypebasicPDiPList;



// WEBPACK FOOTER //
// ./src/redux/selectors/derivatesSelectors.ts